module.exports = __webpack_public_path__ + "static/assets/9f4d6dcfdfb20da9c647d564333e646e.svg";